namespace $.$$ {

	$mol_style_define( $bog_music_select, {
		Bubble_pane: {
			maxHeight: 'none',
		},
	})

}
